import { SPOOL_STATUS_LABELS, type Spool, type SpoolStatus } from '@deizi/shared';
import { formatG } from '../../lib/inventory-api';

export const SPOOL_BADGE: Record<SpoolStatus, string> = {
  sealed: 'badge',
  opened: 'badge ok',
  loaded: 'badge info',
  empty: 'badge err',
};

/** "Carregado · X2D slot 2" */
export function spoolStatusText(s: Spool): string {
  if (s.status === 'loaded' && s.location) {
    const where = s.location.slot === 'ext' ? 'externo' : `slot ${s.location.slot}`;
    return `${SPOOL_STATUS_LABELS.loaded} · ${s.location.printerName} ${where}`;
  }
  return SPOOL_STATUS_LABELS[s.status];
}

/** Where the spool is: "X2D slot 2", the shelf note or "—". */
export function spoolPlace(s: Spool): string {
  if (s.location) {
    return `${s.location.printerName} ${s.location.slot === 'ext' ? 'externo' : `slot ${s.location.slot}`}`;
  }
  if (s.status === 'empty') return '—';
  return s.locationNote ? `Prateleira · ${s.locationNote}` : 'Prateleira';
}

export function SpoolBadge({ spool }: { spool: Spool }) {
  return <span className={SPOOL_BADGE[spool.status]}>{spoolStatusText(spool)}</span>;
}

/** Grams left with a bar (warn when low). */
export function GramsBar({ spool, width = 90 }: { spool: Spool; width?: number }) {
  const pct =
    spool.initialGrams > 0 ? Math.min(100, (spool.remainingGrams / spool.initialGrams) * 100) : 0;
  return (
    <span className="row" style={{ gap: 8, justifyContent: 'flex-end' }}>
      <span
        aria-hidden="true"
        style={{
          width,
          height: 8,
          borderRadius: 4,
          background: 'var(--sunk)',
          overflow: 'hidden',
          flex: `0 0 ${width}px`,
        }}
      >
        <span
          style={{
            display: 'block',
            height: '100%',
            width: `${pct}%`,
            background: spool.low ? 'var(--warn)' : 'var(--pe)',
          }}
        />
      </span>
      <span
        className="tab"
        style={{ color: spool.low ? 'var(--warn)' : undefined, minWidth: 64, textAlign: 'right' }}
      >
        {formatG(spool.remainingGrams)}
      </span>
    </span>
  );
}

export { Swatch } from '../../components/Swatch';
